import React from 'react';
import { Body2 } from '@xo-union/tk-ui-typography';
import styles from './sub-nav-item.css';

export default function SubNavLinkItem({ item, isActive, isBadge=false }) {
  const { href, label } = item;
  const trackAttributes = (item) => ({
    'data-event-name': 'Menu Interaction',
    'data-selection': item.label.toLocaleLowerCase(),
    'data-user-decision-area': 'sub nav',
  });

  return (
    isBadge
    ? <Body2 as='a' bold key={item.href} href={item.href} className={styles['badge']} {...trackAttributes(item)}>{item.label}</Body2>
    : <li className={`${styles.item} ${isActive ? styles.active : ''}`}>
        <Body2 as='a' href={href} className={styles.link} {...trackAttributes(item)}>
          {label}
        </Body2>
      </li>
  );
}
